function convertVideoUrlToEmbedUrl(videoUrl) {
  if (videoUrl) {
    const url = new URL(videoUrl);

    // 判断是否为 Bilibili 视频
    if (url.hostname.includes("bilibili.com")) {
      const bvidMatch = videoUrl.match(/BV\w+/);
      if (!bvidMatch) {
        throw new Error("无法提取 Bilibili 视频 ID");
      }
      const bvid = bvidMatch[0];
      const p = 1; // 默认 p 为 1
      return `//player.bilibili.com/player.html?bvid=${bvid}&p=${p}&autoplay=0`;
    }

    // 判断是否为腾讯视频
    if (url.hostname.includes("v.qq.com")) {
      const pathnameParts = url.pathname.split("/");
      let videoIdMatch;
      if (pathnameParts.includes("cover") || pathnameParts.includes("page")) {
        videoIdMatch =
          pathnameParts[pathnameParts.length - 1].match(/(\w+)\.html/);
      }
      if (!videoIdMatch) {
        throw new Error("无法提取腾讯视频 ID");
      }
      const videoId = videoIdMatch[1];
      return `https://v.qq.com/txp/iframe/player.html?vid=${videoId}`;
    }

    // 判断是否为优酷视频
    if (url.hostname.includes("youku.com")) {
      const videoIdMatch = videoUrl.match(/id_(\w+)=/);
      if (!videoIdMatch) {
        throw new Error("无法提取优酷视频 ID");
      }
      const videoId = videoIdMatch[1];
      return `https://player.youku.com/embed/${videoId}`;
    }

    // 判断是否为爱奇艺视频
    if (url.hostname.includes("iqiyi.com")) {
      const videoIdMatch = videoUrl.match(/vid=(\w+)/);
      if (!videoIdMatch) {
        throw new Error("无法提取爱奇艺视频 ID");
      }
      const videoId = videoIdMatch[1];
      return `https://open.iqiyi.com/developer/player_js/coopPlayerIndex.html?vid=${videoId}&autoplay=0`;
    }

    // 如果不是以上任何一种来源，抛出错误
    throw new Error("不支持的视频来源");
  }
}
/**
 * 隐藏手机号中间四位
 * @param {string} phone - 原始手机号码
 * @returns {string} - 处理后的手机号码
 */
function hideMiddleFour(phone) {
  // 使用正则表达式匹配手机号码格式，并替换中间四位为 '*'
  if (!phone) return "";
  return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
}
const tool = { convertVideoUrlToEmbedUrl, hideMiddleFour };

export default tool;
